<script>
    import _ from "lodash";
    export default {
        name: "AjaxLoad",
        props: {
            promise: {
                validator(p) {
                    return (p && typeof p.then === 'function' && typeof p.catch === 'function');
                }
            },
            url: String,
            query: Object,
            value: null,
            saved: Boolean,
            transform: Function,
            active: {
                type: [Number, Boolean, String],
                default: true,
            },
            debounce: Number,
            errorHandler: {
                type: Function,
                default: function (e) {
                    this.notifyError(e);
                },
            },
            priority: {
                type: Boolean,
                default: true,
            },
        },
        data() {
            return {
                resolved: false,
                local: {
                    value: this.value,
                    promise: null
                }
            };
        },
        computed: {
            request() {
                return this.debounce ? _.debounce(this.requestImmediate, this.debounce) : this.requestImmediate;
            },
            savedSync: {
                set(v) {
                    this.$emit('update:saved', v);
                },
                get() {
                    return this.saved;
                }
            },
            data: {
                set(v) {
                    this.$emit('input', v);
                    this.local.value = v;
                },
                get() {
                    return (this.value || this.local.value);
                }
            },
            requestData() {
                return {
                    url: this.url,
                    query: this.query,
                    active: this.active,
                };
            }
        },
        watch: {
            value: {
                handler() {
                    if (this.resolved) {
                        this.savedSync = false;
                    }
                },
                deep: true
            },
            requestData: {
                handler(request, requestOld) {
                    if (request.url && this.active && !_.isEqual(request, requestOld)) {
                        this.createPromise();
                    }
                },
                deep: true,
                immediate: true
            },
            promise: {
                handler (promise) {
                    if (promise) {
                        this.cancelRequest();
                        this.local.promise = promise;
                        this.setHandlers(promise);
                    }
                },
                immediate: true
            },
            resolved: {
                handler(v) {
                    this.$emit('update:resolved', v);
                },
                immediate: true,
            }
        },
        methods: {
            load() {
                return this.createPromise();
            },
            createPromise() {
                return this.get(this.requestData.url, this.requestData.query)
            },
            get(url, query) {
                return this.request({
                    method: 'get',
                    url: url,
                    params: query,
                    priority: this.priority,
                });
            },
            post(url, query) {
                return this.request({
                    method: 'post',
                    url: url,
                    data: query,
                    priority: this.priority,
                });
            },
            requestImmediate(params) {
                this.cancelRequest();
                this.local.promise = this.$api.request(params);
                this.setHandlers(this.local.promise);
                return this.local.promise;
            },
            setHandlers(promise) {
                this.resolved = false;
                this.$emit('loading');
                promise
                    .then((response) => {
                        if (this.transform) {
                            response = this.transform(response);
                        }
                        this.data = response;
                        this.savedSync = true;
                        return response;
                    })
                    .catch((...args) => {
                        return this.errorHandler && this.errorHandler.apply(this, args);
                    })
                    .finally((response) => {
                        if (this.local.promise===promise) {
                            this.$nextTick(() => {
                                this.resolved = true;
                            });
                        }
                        this.$emit('loaded');
                        return response;
                    });
            },
            cancelRequest() {
                if(!this.resolved && this.local.promise && this.local.promise.cancel) {
                    this.local.promise.cancel();
                }
            },
            clear() {
                this.cancelRequest();
                this.data = null;
                this.savedSync = true;
            }, 
        },
        render() {
            return this.$scopedSlots.default ? this.$scopedSlots.default(this) : this.$slots.default;
        },
        beforeDestroy() {
            this.cancelRequest();
        }
    }
</script>
